// src/utils/searchUtils.js

/**
 * 搜索工具类
 */
export class SearchUtils {
    /**
     * 生成6位随机搜索号（字母+数字）
     * @returns {string} 6位随机搜索号
     */
    static generateSearchId() {
        return Math.random().toString(36).substring(2, 8);
    }
}


// 默认导出
export default {
    generateSearchId() {
        return Math.random().toString(36).substring(2, 8);
    }
}



// WEBPACK FOOTER //
// ./src/utils/searchUtils.js